import { BookingItemInterface } from 'Models/UI/BookingItemInterface';
import { TS_Addon }             from '../TravelSeller/Models/TS_Addon';

export class Addon extends TS_Addon implements BookingItemInterface {
}